<template>
  <div>
    <section id="header">
      <header>
        <template v-if="back">
          <div class="back" @click="$router.go(-1)">
            {{ $t("miclive.ui.back") }}
          </div>
        </template>
        <template v-else>
          <div class="menu" @click="toggleMenu()"></div>
          <div class="title">{{ title }}</div>
        </template>
        <router-link :to="'/'">
          <div class="logo"></div>
        </router-link>
      </header>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    back: Boolean
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    toggleMenu() {
      this.$emit("toggleMenu");
    }
  },
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#header {
  width: 100%;
  height: 60px;
  position: fixed;
  left: 0;
  top: 0;
  padding: 5px 10px;
  z-index: 10;
  background: #fff;
  background: $main-color;
  text-align: center;

  .back {
    background: url("~@/../public/img/back_arrow.svg") no-repeat center left 5px;
    background-size: 30px;
    float: left;
    color: #fff;
    line-height: 50px;
    padding: 0;
    padding-left: 40px;
    margin: 0;
  }

  .logo {
    width: 70px;
    height: 50px;
    background: url("~@/../public/img/logo.png") no-repeat center;
    background-size: 70px;
    float: right;
  }

  .menu {
    float: left;
    background: url("~@/../public/img/menu.svg") no-repeat center;
    background-size: 35px;
    width: 50px;
    height: 50px;
    cursor: pointer;
  }
  .title {
    float: left;
    font-size: 1.2rem;
    line-height: 50px;
    color: #fff;
    width: calc(100% - 140px);
    margin-left: 20px;
    font-family: $font-title;
  }
}
</style>
